import React from 'react';
import {FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import {DenominatorType} from "../types";

interface DenominatorSelectorProps {
    selectedDenominator: DenominatorType;
    setSelectedDenominator: (value: DenominatorType) => void;
}

const DenominatorSelector: React.FC<DenominatorSelectorProps> = ({ selectedDenominator, setSelectedDenominator }) => {
    const handleDenominatorChange = (event: SelectChangeEvent<DenominatorType>) => {
        setSelectedDenominator(event.target.value as DenominatorType);
    };

    return (
        <FormControl sx={{ minWidth: 100 ,  marginRight: '1rem'}}>
            <InputLabel>Denominator Unit</InputLabel>
            <Select
                value={selectedDenominator}
                onChange={handleDenominatorChange}
                label="Denominator Unit"
                size="small"
            >
                <MenuItem value="mg">mg</MenuItem>
                <MenuItem value="item">item</MenuItem>
            </Select>
        </FormControl>
    );
};

export default DenominatorSelector;
